/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.images.controllers', [
  'ui.router',
  'ui.bootstrap',
  'ui.sortable',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.service.posConfig',
  'acme.common.factory.notice',
  'acme.view.application.pos.create.images.removeModal.controllers',
])

.controller('PosCreateImagesController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'HelpersService', 'ValidateService', 'PermissionsService', 'PosConfigService', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, ApiService, HelpersService, ValidateService, PermissionsService, PosConfigService, NoticeFactory) {

  $scope.posCreateImages = {

    model: {
      displayTime: 5,
      images: []
    },

    sortable: {

      axis: 'y',

      update: function(e, ui) {
        $scope.posCreateImages.onSortableUpdate(e, ui);
      }

    },

    notice: new NoticeFactory(),

    init: function() {

      $scope.$on('upload::selectionChange', this.onUploadSelectionChange);
      $scope.$on('upload::queueUpdated', this.onUploadQueueUpdated);
      $scope.$on('upload::remove', this.onUploadRemove);
      $scope.$on('upload::done', this.onUploadDone);
      $scope.$on('upload::add', this.onUploadAdd);
      $scope.$on('upload::error', this.onUploadError);

      $scope.$on('PosCreateController::Save', this.onPosCreateSave);
      $scope.$on('PosCreateController::UpdateModel', this.onPosCreateUpdateModel);

      this.getImages();

    },

    getImages: function() {
      this.model = PosConfigService.images.getModel(true);
      this.process();
      if (!this.model.displayTime) {
        this.model.displayTime = 5;
      }
    },

    process: function() {
      var lastOrder = 1, i, ii;

      for (i = 0, ii = this.model.images.length; i < ii; i++) {
        if (this.model.images[i].order !== undefined) {
          if (lastOrder <= this.model.images[i].order) {
            lastOrder = this.model.images[i].order + 1;
          }
        } else {
          //there is no order, assign one
          this.model.images[i].order = lastOrder;
          lastOrder = lastOrder + 1;
        }
      }
    },

    move: function(id, direction) {
      var found = this.findImage(id);

      if (found !== false) {
        this['move' + HelpersService.cap(direction)](found.index);
      }
    },

    moveUp: function(index) {
      var i, ii,
          tmp;

      if (index > 0) {
        tmp = this.model.images.splice(index, 1)[0];
        this.model.images.splice(index - 1, 0, tmp);
      }
      for (i=0,ii=this.model.images.length;i<ii;i++) {
        this.model.images[i].order = i + 1;
      }
    },

    moveDown: function(index) {
      var i, ii,
          tmp;

      if (index < this.model.images.length - 1) {
        tmp = this.model.images.splice(index, 1)[0];
        this.model.images.splice(index + 1, 0, tmp);
      }
      for (i=0,ii=this.model.images.length;i<ii;i++) {
        this.model.images[i].order = i + 1;
      }
    },

    moveSort: function() {
      var i, ii;

      for (i = 0, ii = this.model.images.length; i < ii; i++) {
        this.model.images[i].order = i + 1;
      }
    },

    moveManual: function(index) {
      var i, ii,
          tmp;

      if (index !== this.model.images[index].order - 1) {
        if (this.model.images[index].order < 1) {
          this.model.images[index].order = 1;
        } else if (this.model.images[index].order > this.model.images.length) {
          this.model.images[index].order = this.model.images.length;
        }

        if (index < this.model.images.length) {
          tmp = this.model.images.splice(index, 1)[0];
          this.model.images.splice(tmp.order - 1, 0, tmp);
        }

        for (i = 0, ii = this.model.images.length; i < ii; i++) {
          this.model.images[i].order = i + 1;
        }
      }
    },

    findImage: function(id) {

      var i, ii,
          r = false;

      for (i=0,ii=this.model.images.length;i<ii;i++) {
        if (this.model.images[i].id === id) {
          r = {
            image: this.model.images[i],
            index: i
          };
          break;
        }
      }

      return r;

    },

    checkTime: function() {
      var i, ii;

      for (i = 0, ii = this.model.images.length; i < ii; i++) {
        if (this.model.displayTime <= 4) {
          this.model.displayTime = 5;
        }
        if (this.model.displayTime <= this.model.images[i].transitionTime) {
          this.model.images[i].transitionTime = this.model.displayTime - 1;
        }
        if (this.model.images[i].transitionTime < 0) {
          this.model.images[i].transitionTime = Math.abs(this.model.images[i].transitionTime);
        }
      }

    },

    remove: function(id) {

      var self = $scope.posCreateImages,
          found = self.findImage(id);

      self.removeModal = $uibModal.open({
        templateUrl: 'views/application/views/pos/create/images/modals/removeImage.tpl.html',
        size: 'md',
        controller: 'PosCreateImagesRemoveModalController',
        resolve: {
          currentImage: (found !== false) ? found.image : false
        }
      });

      // Invoked when modal completes with close(params)
      self.removeModal.result.then(function () {
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        self.isRemoving = true;

        self.model.images.splice(found.index, 1);

        self.moveSort();

        $scope.$emit('PosCreateImagesController::Update');
      }, function () {
        // Do nothing
      });

    },

    success: {
      init: function(response) {},
      getImages: function(response) {},
      removeImage: function(response) {}
    },

    error: {
      init: function(response) {},
      getImages: function(response) {},
      removeImage: function(response) {}
    },

    onPosCreateSave: function(e, data) {
      PosConfigService.images.setModel($scope.posCreateImages.model);
    },

    onPosCreateUpdateModel: function(e, data) {
      var self = $scope.posCreateImages;
      PosConfigService.images.setModel(PosConfigService.images.getModel());
      self.getImages();
    },

    onSortableUpdate: function(e, data) {
      // next tick
      $timeout(function() {
        $scope.posCreateImages.moveSort();
      }, 0);
    },

    onUploadRemove: function(e, data) {
      var i, ii,
        self = $scope.posCreateImages;
      self.notice.hideErrorMessages();

      for (i=0,ii=self.model.images.length;i<ii;i++) {
        if (data.file.id === self.model.images[i].id) {
          self.model.images.splice(i, 1);
        }
      }
      console.log('PosCreateImagesController::onUploadRemove', self.model.images);
    },

    onUploadDone: function(e, data) {
      var self = $scope.posCreateImages;
      self.notice.hideErrorMessages();

      console.log('PosCreateImagesController::onUploadDone', data);

      if (!(self.model.images instanceof Array)) {
        self.model.images = [];
      }

      self.model.images.push({
        id: data.file.uuid,
        order: self.model.images.length + 1,
        imageUrl: HelpersService.correctORImage(data.file.originalPath),
        thumbnailImageUrl: data.file.previewPath,
        transitionTime: 2
      });

      console.log('PosCreateImagesController::onUploadDone', self.model.images);

      $scope.$apply();

      $scope.$emit('PosCreateImagesController::Update');

    },

    onUploadError: function(e, data) {
      $scope.posCreateImages.notice.showErrorMessages([
        {
          message: data.result.error || 'There was a problem uploading that file.'
        }
      ]);
    },

    onUploadAdd: function(e, data) {
      $scope.posCreateImages.notice.hideErrorMessages();
    },
    onUploadSelectionChange: function(e, data) {},
    onUploadQueueUpdated: function(e, data) {
      $scope.posCreateImages.notice.hideErrorMessages();
    }

  };

  $scope.posCreateImages.init();

}]);